<template>
  <div class="c-filter-search" :class="[isSearchOpen ? 'c-filter-search--active' : '']">
    <form @submit.prevent="updateValue" class="c-filter-search__form u-bg-color-brand-two-whiten-10" :class="[isSearchOpen ? 'c-filter-search__form--active' : '']">
      <label for="searchList" class="visually-hidden">{{ label }}</label>
      <input id="searchList" ref="searchInput" v-model="internalValue" name="searchList" class="c-filter-search__input" type="placeholder">
      <div class="c-filter-search__buttons">
        <div class="c-filter-search__button-items c-filter-search__button-items--order-last">
          <button class="c-filter-search__button-search">
            <span class="visually-hidden">Search</span>
            <svg class="c-filter-search__button-icon" aria-hidden="true" focusable="false">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#search"></use>
            </svg>
          </button>
        </div>
        <div class="c-filter-search__button-items" v-if="internalValue.length > 0">
          <button class="c-filter-search__button-clear" @click.prevent="clearInput">
            <span class="visually-hidden">Clear search Box</span>
            <svg class="c-filter-search__button-icon" aria-hidden="true" focusable="false">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use>
            </svg>
          </button>
        </div>
      </div>
    </form>
    <button class="c-filter-search__toggle" @click="toggleSearchInput">
      <span class="visually-hidden">Toggle search box visibility</span>
      <svg class="c-filter-search__open-icon" aria-hidden="true" focusable="false">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#search"></use>
      </svg>
      <svg class="c-filter-search__close-icon" aria-hidden="true" focusable="false">
        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#close"></use>
      </svg>
    </button>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      value: {
        type: String,
        required: false,
        default: ''
      },
    },
    data() {
      return {
        isSearchOpen: false,
        internalValue: '',
      }
    },
    methods: {
        focusInput() {
          this.$nextTick(() => {
                this.$refs.searchInput.focus()
            });
        },
        updateValue() {
            this.$emit('input', this.internalValue)
            this.$emit('changed', true)
        },
        clearInput() {
            this.internalValue = ''
            this.$emit('input', '')
            this.focusInput()
            this.$emit('changed', true)
        },
        toggleSearchInput() {
          this.isSearchOpen = !this.isSearchOpen
          this.$emit('toggleSearchOpen', this.isSearchOpen)
          if(this.isSearchOpen) {
            this.focusInput()
          }
        }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/_filter/filter-search/FilterSearch.vue